module.exports = __webpack_public_path__ + "media/auto_history/dodanie_wspolwlasciciela-d51d31a3.svg";